import { render, staticRenderFns } from "./Meltmedia.vue?vue&type=template&id=5f1b4713&scoped=true&"
import script from "./Meltmedia.vue?vue&type=script&lang=js&"
export * from "./Meltmedia.vue?vue&type=script&lang=js&"
import style0 from "./Meltmedia.vue?vue&type=style&index=0&id=5f1b4713&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f1b4713",
  null
  
)

export default component.exports